const KEY = "scadox_portal_tokens";

export interface StoredTokens {
  idToken: string;
  accessToken: string;
  refreshToken: string;
  email: string;
}

export function saveTokens(t: StoredTokens): void {
  sessionStorage.setItem(KEY, JSON.stringify(t));
}

export function loadTokens(): StoredTokens | null {
  const raw = sessionStorage.getItem(KEY);
  return raw ? (JSON.parse(raw) as StoredTokens) : null;
}

export function clearTokens(): void {
  sessionStorage.removeItem(KEY);
}
